import { useEffect, useState } from "react";
import * as d3 from "d3";
import diamondData from '../../../data/diamond_data.js'
import chart from './SVGDiamond2025_squared.jsx'

function Genders (props) {

  const data = props.data

  const [sort, setSort] = useState('match_right')

  const tab = {
    label: '12em',
    match: '30em',
    chart: '3em',
    number: '3em',
    chnum: '6em'
  }

  const colors = {
    right: 'rgb(34, 196, 169)',
    umbrella: 'rgb(34, 196, 126)',
    close: 'rgb(225, 147, 88)',
    wrong: 'rgb(225, 116, 88)'
  }

  const max = {
    problem: d3.max(data, d => d.report_problem),
    quality: d3.max(data, d => d.report_quality),
    binary: d3.max(data, d => d.binary_answers),
    time: d3.max(data, d => d.time_mean),
    report: d3.max([d3.max(data, d => d.report_problem),d3.max(data, d => d.report_quality)])
  }

  function drawGenders(){

    const sorted = data.sort((a, b) => d3.descending(a[sort], b[sort]));

    d3.select('#genders_rows').selectAll('.table_row').data(sorted).join(
      function(enter){
        const row = enter.append('div')
          .attr('class', 'table_row')
          .style('background-color', (d,i) => i%2===0 ? 'rgb(255,255,255,0.07)' : 'rgb(255,255,255,0.035)')

        row.append('div')
          .attr('class', 'label')
          .style('width', tab.label)
          .html(d => d.gender_label)

        const match = row.append('div')
          .attr('class', 'matches')
          .style('width', tab.match)

        match.append('div')
          .attr('class', 'count_rect match_right')
          .style('display', d => d.match_right === 0 ? 'none' : undefined)
          .style('width', d => d.match_right * 30 + 'em')
          .style('background-color', d => ['queer', 'nonbinary'].includes(d.gender_id) ? colors.umbrella : colors.right)
          .html(d => Math.round(100 * d.match_right)+'%')

        match.append('div')
          .attr('class', 'count_rect match_close')
          .style('display', d => d.match_close === 0 ? 'none' : undefined)
          .style('width', d => d.match_close * 30 + 'em')
          .style('background-color', colors.close)
          .html(d => Math.round(100 * d.match_close)+'%')

        match.append('div')
            .attr('class', 'count_rect match_wrong')
            .style('display', d => d.match_wrong === 0 ? 'none' : undefined)
            .style('width', d => d.match_wrong * 30 + 'em')
            .style('background-color', colors.wrong)
            .html(d => Math.round(100 * d.match_wrong)+'%')

        const problem = row.append('div')
          .attr('class', 'problem')
          .style('display', 'flex')
          .style('align-items', 'center')

        problem.append('div')
          .attr('class', 'number')
          .style('width', tab.number)
          .html(d => Math.round(100 * d.report_problem)+'%')

        problem.append('div')
          .style('width', tab.chart)
          .append('div')
            .attr('class', 'count_rect')
            .style('background-color', 'gray')
            .style('width', d => (d.report_problem / max.report * 3) + 'em')

        const quality = row.append('div')
          .attr('class', 'quality')
          .style('display', 'flex')
          .style('align-items', 'center')

        quality.append('div')
          .attr('class', 'number')
          .style('width', tab.number)
          .html(d => Math.round(100 * d.report_quality)+'%')

        quality.append('div')
          .style('width', tab.chart)
          .append('div')
            .attr('class', 'count_rect')
            .style('background-color', 'gray')
            .style('width', d => (d.report_quality / max.report * 3) + 'em')

        const binary = row.append('div')
          .attr('class', 'binary')
          .style('display', 'flex')
          .style('align-items', 'center')

        binary.append('div')
          .attr('class', 'number')
          .style('width', tab.number)
          .html(d => Math.round(100 * d.binary_answers)+'%')

        binary.append('div')
          .style('width', tab.chart)
          .append('div')
            .attr('class', 'count_rect')
            .style('background-color', 'gray')
            .style('width', d => (d.binary_answers / max.binary * 3) + 'em')

        const time = row.append('div')
          .attr('class', 'time')
          .style('display', 'flex')
          .style('align-items', 'center')

        time.append('div')
          .attr('class', 'number')
          .style('width', tab.number)
          .html(d => Math.round(d.time_mean) + ' s')

        time.append('div')
          .style('width', tab.chart)
          .append('div')
            .attr('class', 'count_rect')
            .style('background-color', 'gray')
            .style('width', d => (d.time_mean / max.time * 3) + 'em')
      },
      function(update){
        
        update.select('.label').html(d => d.gender_label)

        update.select('.match_right')
          .style('display', d => d.match_right === 0 ? 'none' : undefined)
          .style('width', d => d.match_right * 30 + 'em')
          .style('background-color', d => ['queer', 'nonbinary'].includes(d.gender_id) ? colors.umbrella : colors.right)
          .html(d => Math.round(100 * d.match_right)+'%');

        update.select('.match_close')
          .style('display', d => d.match_close === 0 ? 'none' : undefined)
          .style('width', d => d.match_close * 30 + 'em')
          .html(d => Math.round(100 * d.match_close)+'%');

        update.select('.match_wrong')
            .style('display', d => d.match_wrong === 0 ? 'none' : undefined)
            .style('width', d => d.match_wrong * 30 + 'em')
            .html(d => Math.round(100 * d.match_wrong)+'%');

        update.select('.problem').select('.number').html(d => Math.round(100 * d.report_problem)+'%')
        update.select('.problem').select('.count_rect').style('width', d => (d.report_problem / max.report * 3) + 'em')
        update.select('.quality').select('.number').html(d => Math.round(100 * d.report_quality)+'%')
        update.select('.quality').select('.count_rect').style('width', d => (d.report_quality / max.report * 3) + 'em')
        update.select('.binary').select('.number').html(d => Math.round(100 * d.binary_answers)+'%')
        update.select('.binary').select('.count_rect').style('width', d => (d.binary_answers / max.binary * 3) + 'em')
        update.select('.time').select('.number').html(d => Math.round(d.time_mean) + ' s')
        update.select('.time').select('.count_rect').style('width', d => (d.time_mean / max.time * 3) + 'em')
      }
    )
  }

  function updateSortMatch(){
    if (sort === 'match_right') setSort('match_close')
    else if (sort === 'match_close') setSort('match_wrong')
    else setSort('match_right')
  }

  useEffect(() => {
    drawGenders()
  });

  return (
    <div id="genders" className="table">
      <div className="table_row head_row">
          <div className="table_head" style={{width: tab.label}} onClick={() => setSort('gender_label')}>Prompt</div>
          <div className="table_head" style={{width: tab.match}} onClick={() => updateSortMatch()}>Match</div>
          <div className="table_head" style={{width: tab.chnum}} onClick={() => setSort('report_problem')}>Problematic</div>
          <div className="table_head" style={{width: tab.chnum}} onClick={() => setSort('report_quality')}>Low quality</div>
          <div className="table_head" style={{width: tab.chnum}} onClick={() => setSort('binary_answers')}>Binarity</div>
          <div className="table_head" style={{width: tab.chnum}} onClick={() => setSort('time_mean')}>Mean time</div>
      </div>
      <div id="genders_rows" className="table_rows"></div>
      {/* <Chart/> */}
    </div>
  );
}

export default Genders;
